<template>
  <div class="drawer-box">
    <h1 class="title" v-html="details.data.title"></h1>
    <div class="release-box">
      <div>发布时间：{{ details.data.createTime }}</div>
      <!-- <div>创建人：{{details.createUser}}</div> -->
      <div>创建人：{{ details.createUserName }}</div>
    </div>
    <div class="drawer-content-box" style="position: relative">
      <div class="drawer-content">
        <div class="item">
          <span class="label">课程封面：</span>
          <img
            class="content-img"
            v-lazy="$global.imgUrl + details.data.cover"
            alt=""
          />
        </div>
        <div class="item">
          <span class="label">课程详情：</span>
          <span class="content" v-html="details.data.content"></span>
        </div>
        <div class="item">
          <span class="label">售卖方式：</span>
          <span class="content">{{ details.data.saleType == 0 ? '免费' : '付费' }}</span>
        </div>
        <div class="item" v-if="details.data.saleType == 1">
          <span class="label">售卖价格：</span>
          <span class="content">{{ details.data.salePrice }}</span>
        </div>
        <div class="item">
          <span class="label">课程地址：</span>
          <span class="content">{{ details.data.urlAddr }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  created() {
    this.getEcho(this.id, 9);
  },
  data() {
    return {
      details: {},
    };
  },
  methods: {
    // 获取详情
    async getEcho(articleId, articleType) {
      const resp = await this.$apis.userServe.getEcho({
        articleId,
        articleType,
      });
      this.details = resp.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-box {
  padding: 0 20px 20px;
  .title {
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
  }
  .release-box {
    margin: 10px 0 25px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
  }
  .column {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #3c3c3c;
    .tab {
      margin-right: 20px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
    }
    .is-tab {
      color: #0b35c5;
    }
  }
  .drawer-content-box {
    position: relative;
    .demo-spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
    }
    &::v-deep .ivu-spin-fix {
      background-color: rgb(255 255 255);
    }
    .drawer-content {
      margin-top: 25px;
      .item {
        display: flex;
        margin-bottom: 10px;
        .label {
          margin-right: 15px;
          width: 85px;
          font-size: 14px;
          font-weight: bold;
          color: #333333;
          line-height: 30px;
        }
        .content {
          flex: 1;
          font-size: 14px;
          color: #000000;
          line-height: 30px;
          .file-name {
            display: inline-block;
            max-width: 300px;
          }
          .file-btn {
            color: #152ead;
            cursor: pointer;
          }
          &::v-deep img,
          &::v-deep video {
            max-width: 100% !important;
          }
          &::v-deep span {
            white-space: normal !important;
          }
          .committee {
            display: flex;
            margin-bottom: 50px;
            color: #333333;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        .more-auther {
          &::after {
            content: "，";
          }
          &:last-child {
            &::after {
              content: "";
            }
          }
        }
        .content-img {
          width: 250px;
          height: 200px;
        }
      }
      .list-box {
        display: flex;
        flex-wrap: wrap;
        .list-item {
          margin-right: 20px;
          margin-bottom: 25px;
          width: 250px;
          &:nth-child(4n) {
            margin-right: 0;
          }
          .item-img {
            position: relative;
            width: 100%;
            height: 150px;
            img {
              width: 100%;
              height: 100%;
            }
            video {
              width: 100%;
              height: 100%;
            }
            .mask {
              display: none;
              position: absolute;
              background: rgba(61, 60, 60, 0.779);
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              line-height: 150px;
              text-align: center;
              color: #fff;
            }
            &:hover .mask {
              display: block;
            }
          }
          .item-status {
            display: flex;
            justify-content: space-between;
            margin: 5px 0;
            height: 30px;
            .state {
              display: inline-block;
              margin-right: 5px;
              padding: 2px 5px;
              text-align: center;
              color: #fff;
              border-radius: 5px;
            }
          }
          .item-name {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

.img-upload-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  .img-upload-list {
    position: relative;
    margin: 0 10px 20px;
    width: 160px;
    .img {
      width: 100%;
      height: 160px;
      border: 1px solid #999;
      border-radius: 5px;
    }
    .img-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .img-upload-icon {
      position: absolute;
      top: -8px;
      right: -8px;
      cursor: pointer;
    }
  }
  .img-upload-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 10px;
    width: 160px;
    height: 160px;
    color: #1989fa;
    text-align: center;
    border: 1px dashed #e4e4e4;
    border-radius: 5px;
    .plus {
      font-size: 50px;
    }
  }
}
.progress-box {
  margin: 20px 0;
  .progress {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #d7d7d7;
    border-radius: 5px;
  }
  .progress-title {
    font-size: 18px;
  }
}
</style>